module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "do-table",
    class: {
      'is-absence-integration-active': _vm.isAbsenceIntegrationActive
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), (_vm.isAbsenceIntegrationActive && _vm.isSalarySystemKMD) ? _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window',
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
    }],
    staticClass: "hide-title-th width-40 text-left",
    attrs: {
      "content": "Fraværskoden er den kode, der skal bruges i Opus, når en medarbejder har fravær. Vælges en kode, vil der automatisk blive oprettet en fraværsindberetning i Opus."
    }
  }, [_vm._v("Fraværskode i OPUS "), _c('span', {
    staticClass: "icon-question3"
  })]) : _vm._e(), _vm._v(" "), (_vm.isAbsenceIntegrationActive && _vm.isSalarySystemSD) ? _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window',
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
    }],
    staticClass: "hide-title-th width-40 text-left",
    attrs: {
      "content": "Fraværskoden er den kode, der skal bruges i SD, når en medarbejder har fravær. Vælges en kode, vil der automatisk blive oprettet en fraværsindberetning i SD."
    }
  }, [_vm._v("Fraværskode i SD "), _c('span', {
    staticClass: "icon-question3"
  })]) : _vm._e(), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window',
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
    }],
    staticClass: "hide-title-th",
    attrs: {
      "content": _vm.tooltipForHideTitle
    }
  }, [_vm._v(_vm._s(_vm.i18n['hide_title']) + " "), _c('span', {
    staticClass: "icon-question3"
  })]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window',
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
    }],
    staticClass: "hide-title-th",
    attrs: {
      "content": _vm.tooltipForDefaultOngoing
    }
  }, [_vm._v(_vm._s(_vm.i18n['default_ongoing']) + " "), _c('span', {
    staticClass: "icon-question3"
  })]), _vm._v(" "), (_vm.isAbsenceRequestActivated) ? _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window',
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n            }"
    }],
    staticClass: "hide-title-th",
    attrs: {
      "content": _vm.tooltipForCanBeRequested
    }
  }, [_vm._v(_vm._s(_vm.i18n['can_be_requested']) + " "), _c('span', {
    staticClass: "icon-question3"
  })]) : _vm._e(), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(reason) {
    return _c('tr', {
      key: reason.id
    }, [_c('td', [_vm._v(_vm._s(reason.name))]), _vm._v(" "), (_vm.isAbsenceIntegrationActive && _vm.isSalarySystemKMD) ? _c('td', {
      staticClass: "width-40"
    }, [(reason.kmd_absence_code_id && _vm.editingAbsenceCodeId !== reason.id) ? _c('div', {
      staticClass: "absence-code-display"
    }, [_c('span', {
      staticClass: "absence-code-text"
    }, [_vm._v(_vm._s(_vm.getAbsenceCodeName(reason.kmd_absence_code_id, false)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAbsenceIntegrationActive && _vm.isSalarySystemSD) ? _c('td', {
      staticClass: "width-40"
    }, [(reason.sd_absence_code_id) ? _c('div', {
      staticClass: "absence-code-display"
    }, [_c('span', {
      staticClass: "absence-code-text"
    }, [_vm._v(_vm._s(_vm.getAbsenceCodeName(reason.sd_absence_code_id, true)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "hide-title-td"
    }, [_c('div', {
      staticClass: "do-table-flex",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onToggleDefaultPrivate(reason)
        }
      }
    }, [_c('AppToggle', {
      attrs: {
        "propOn": reason.default_private,
        "allowChanges": false
      }
    })], 1)]), _vm._v(" "), _c('td', {
      staticClass: "hide-title-td"
    }, [_c('div', {
      staticClass: "do-table-flex default-ongoing-wrapper",
      class: {
        'default-ongoing-disabled': _vm.isDefaultOngoingDisabled(reason)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onToggleDefaultOngoing(reason)
        }
      }
    }, [(_vm.isDefaultOngoingDisabled(reason)) ? _c('div', {
      staticClass: "default-ongoing-overlay"
    }) : _vm._e(), _vm._v(" "), _c('AppToggle', {
      attrs: {
        "propOn": reason.default_ongoing,
        "allowChanges": false
      }
    })], 1)]), _vm._v(" "), (_vm.isAbsenceRequestActivated) ? _c('td', {
      staticClass: "hide-title-td"
    }, [_c('div', {
      staticClass: "do-table-flex",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onToggleCanRequest(reason)
        }
      }
    }, [_c('AppToggle', {
      attrs: {
        "propOn": reason.can_request,
        "allowChanges": false
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "do-bttn do-bttn--small",
      class: {
        'do-bttn--loading': _vm.theUpdatingReasonId === reason.id
      },
      on: {
        "click": function($event) {
          return _vm.$emit('toggleArchived', reason)
        }
      }
    }, [_vm._v(_vm._s(reason.archived ? _vm.i18n['dearchive'] : _vm.i18n['archive']) + "\n      ")])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-790d2854!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AbsenceReasons/AbsenceReasonsTable.vue
// module id = 2026
// module chunks = 1